module.exports = __webpack_public_path__ + "static/media/eric.a93a20bd.png";